import React from "react";
import Marquee from "react-fast-marquee";

const PUBLISHERS = [
  "TechCrunch", "Forbes", "Yahoo", "Business Insider", "Mashable", "Entrepreneur",
  "HuffPost", "The Verge", "Wired", "Inc.", "Fast Company", "Bloomberg",
];

export default function TrustMarquee() {
  return (
    <section className="py-14 border-y border-line bg-white relative" data-testid="trust-marquee">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-6">
        <div className="eyebrow text-center">Trusted publisher network · 4,200+ outlets</div>
      </div>
      <Marquee gradient gradientColor={[255, 255, 255]} speed={40} pauseOnHover>
        {PUBLISHERS.map((name) => (
          <div key={name} className="px-10">
            <span className="font-display text-2xl text-ink/40 tracking-tight">{name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
